// 図形固有の寸法定数。配置・リサイズ・MCP 作成で同じ値を共有し、経路ごとのずれを防ぐ。

/** 矢印をシングルクリックで配置したときの既定サイズ（ステージ px）。 */
export const ARROW_DEFAULT_W = 160;
export const ARROW_DEFAULT_H = 16;

/**
 * 矢印の最小サイズ（ステージ px）。
 * 配置時の短辺下限とリサイズ下限をそろえ、配置直後の不自然な拡大を防ぐ。
 */
export const ARROW_MIN_SIZE_PX = 8;

/**
 * arrowFromEdge / arrowFromCorner のどちらも持たない旧形式の水平矢印の
 * 最小幅（ステージ px）。
 * 固定座標で描く軸と矢じりが崩れず、8px の軸長を確保できる値とする。
 */
export const ARROW_LEGACY_MIN_W_PX = 24;
